'use client';

import { MenuItem, TextField } from '@mui/material';
import React from 'react';

import { paramToSlug, stateFieldOptions } from '../../utils';

interface StateSelectProps {
	label: string;
	value: any;
	onChange: (selection: any) => void;
}

export const StateSelect = ({ label, value, onChange }: StateSelectProps) => (
	<TextField
		id='state'
		select
		required
		label={label}
		value={value || ''}
		style={{ width: '100%' }}
		onChange={(selection) => onChange(selection)}
		data-cy={`${paramToSlug(label)}-select-menu`}
	>
		{stateFieldOptions.map((option) => (
			<MenuItem key={option.value} value={option.value}>
				{option.value}
			</MenuItem>
		))}
	</TextField>
);
